<template>
  <div id="foot">
    <div>
      <div class="box">
        <dl>
          <td>咨询热线</td>
          <dd class="textbig">400-626-5529</dd>
        </dl>
        <dl>
          <td>快速导航</td>
          <dd>产品中心</dd>
          <dd>解决方案</dd>
          <dd>应用案例</dd>
          <dd>关于我们</dd>
        </dl>
        <dl>
          <td>联系我们</td>
          <dd>地址：上海市闵行区马桥镇紫东路55号10号楼（联东U谷人工智能科创园</dd>
          <dd>邮箱：vip@02163.com</dd>
          <dd>电话：400-626-5529</dd>
        </dl>
        <dl>
          <dd class="erweima"><img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/erweima.png" alt=""></dd>
          <dd>微信公众号</dd>
        </dl>
      </div>
    </div>
    <p>
      <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/Officialwebsite/beian.png" style="margin-right: 5px;vertical-align: middle;">
       <a href="https://beian.miit.gov.cn/" target="_blank" class="btngov">
        泸ICP备13002254号-3</a>&nbsp;
      Copyright © 上海旭宇信息科技有限公司;All Rights Reserved
    </p>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {

    };
  },
  methods: {

  },
  components: {

  },
};
</script>

<style scoped>
#foot {
  color: #ffffff;
}
#foot > div {
  background: url('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/dibu_bg.png') no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 360px;
}
#foot .box {
  display: flex;
  justify-content: space-between;
  padding-top: 80px;
}
dl dd:nth-of-type(1) {
  margin-top: 11px;
}
td {
  font-size: 18px;
  line-height: 18px;
  font-family: '胡晓波男神体';
}
dd {
  font-size: 14px;
  line-height: 39px;
}
.textbig {
  font-size: 24px;
  margin-top: 32px !important;
  line-height: 24px;
  font-family: '胡晓波男神体';
}
p {
  font-size: 12px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00152b;
}
.erweima {
  margin: 0 !important;
  height: 170px;
}
.btngov {
  color: #fff;
  text-decoration: none;
}
.btngov:hover {
  color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue